<div class="snackbar" [style.border-color]="data.bg_color">
  <div class="d-flex justify-content-between align-items-center">
    <div class="f-12 poppins-semibold d-flex align-items-center"><div class="ml-2 mr-2"><img [src]="data.image" alt="Your Image" width="28" height="28" /></div>{{ data.text_foot }}</div>
    <div class=" pointer" (click)="closeSnackBar()">
      <span class="material-icons f-16"> close </span>
    </div>
  </div>
  <!-- <img [src]="data.image" alt="Your Image" width="200" height="135" /> -->
  <!-- <footer [style.backgroundColor]="data.bg_color" class="f-14">
    {{ data.text_foot }}
  </footer> -->
</div>
